import type ProductCharacteristic from '~/type/ProductCharacteristic'

export default function (el: any): ProductCharacteristic {
  return {
    title: el.GROUP_NAME,
    list: Object.entries(el.PROPERTIES).map(([name, value]) => ({ name, value: String(value) })),
  }
}
